import React, { useEffect, useState } from 'react'

import { useQuery } from 'react-query'
import { useRouter } from 'next/router'
import { SortEnum } from '@interfaces/SortEnum'
import { useAuthentication } from '@hooks/useAuthentication'
import { WriterSalesAnalyticsDetailDataType } from '@models/myWriting/salesAndAnalytics/WriterSalesAnalyticsDetailDataType'
import { WriterSalesAnalyticsDetailReportEnum } from '@interfaces/WriterSalesAnalyticsDetailReportEnum'
import { WriterSalesGraphTypeEnum } from '@interfaces/WriterSalesGraphTypeEnum'
import { useMyWritingAction } from '@hooks/book/myWriting/useMyWritingAction'
import {
  OverviewTabsAcceptProps,
  OverviewTabsProps,
  SortTableType,
} from './interface'

const initialData: WriterSalesAnalyticsDetailDataType = {
  tableData: [],
  graphData: [],
  graphType: WriterSalesGraphTypeEnum.MONTH,
}

export function withOverviewTabs(Component: React.FC<OverviewTabsProps>) {
  function WithOverviewTabs({
    queryParams,
    ...props
  }: OverviewTabsAcceptProps) {
    const router = useRouter()
    const myWritingClient = useMyWritingAction()
    const { user, isAuthenticated, isWriter } = useAuthentication()
    const [sortParams, setSortParams] = useState<SortTableType>({
      reportType: WriterSalesAnalyticsDetailReportEnum.SALES,
      sortKey: 'total',
      sortValue: SortEnum.DESC,
    })

    const queryKey = [
      'sales-analytics-detail',
      user.id,
      queryParams,
      sortParams,
    ]
    const { data = initialData, isLoading } = useQuery(
      queryKey,
      () =>
        myWritingClient.getWriterSalesAnalyticsDetail(queryParams, sortParams),
      {
        enabled: !!isAuthenticated && isWriter,
      }
    )

    function handleSortChange(sortKey: string, sortValue: SortEnum) {
      setSortParams(prev => ({
        ...prev,
        sortKey,
        sortValue,
      }))
    }

    function handleTabChange(value: string) {
      router.replace(
        {
          pathname: '/my-writing',
          query: {
            ...router.query,
            reportType: value,
          },
        },
        undefined,
        { scroll: false }
      )
    }

    useEffect(() => {
      setSortParams({
        reportType:
          (router.query.reportType as WriterSalesAnalyticsDetailReportEnum) ||
          WriterSalesAnalyticsDetailReportEnum.SALES,
        sortKey: 'total',
        sortValue: SortEnum.DESC,
      })
    }, [router.query.reportType])

    const newProps = {
      ...props,
      queryParams,
      sortParams,
      isLoading,
      data,
      handleTabChange,
      handleSortChange,
    }
    return <Component {...newProps} />
  }
  return WithOverviewTabs
}
